const styles = () => ({
  root: {
    width: "100%",
  },
  card: {
    margin: "24px",
    boxShadow:
      "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)",
    borderRadius: "4px",
  },
  axeptaCard: {
    margin: "24px",
    borderRadius: "4px",
    width: "100%",
  },

  checkbox: {
    padding: "0 !impotant",
  },
  loadingBackdrop: {
    zIndex: 1600,
  },
})

export default styles
